import React, {Component, useEffect, useState} from 'react';
import Divider from '../divider';
import logoGovBR from '../../assets/img/govbrNegativa.svg';
import acessoInformacao from '../../assets/img/acessoainformacao.svg';
import axios from 'axios';

function Footer(props) {
    const larguraFixa = false;
    const fundoInvertido = false;
    const mostrarTituloRedeSocial = true;
    const systemName = 'API Gateway Olinda';

    const [backendVer, setbackendVer] = useState(undefined);

    useEffect(() => {

        axios.get(process.env.REACT_APP_BASE_URL_BACKEND).then((response) => 
        {
            setbackendVer(response.data);
        }).catch((e) => { 
            console.log("Não foi possível obter dados do servidor...");
            console.log("Erro:", e); 
        });

    }, []);


    const categorias = [
        // { name: 'Teste 1', itens: ['Ut placerat ligula. Praesent. ', 'Aenean facilisis sem , at. ', 'Phasellus non dictum dui. In eleifend. '] },
        // { name: 'Teste 2', itens: ['Duis ut placerat . Praesent. ', 'Aenean facilisis sem ante, at. ', 'Phasellus non dui. Quisque in eleifend. '] },
        // { name: 'Teste 3', itens: ['Duis ut placerat ligula. Praesent. ', 'Aenean sem ante, at. ', 'Phasellus non dictum dui. Quisque in eleifend. '] },
    ];

    const redesSociais = [
        <a href='https://www.facebook.com/ministeriodaeducacao/' alt='facebook' className="mr-1">
            <i className='fab fa-facebook-f text-white' />
        </a>,
        <a href='https://www.youtube.com/ministeriodaeducacao' alt='youtube' className="mr-1">
            <i className='fab fa-youtube text-white' />
        </a>,
        <a href='https://www.twitter.com/mec_comunicacao' alt='twitter' className="mr-1">
            <i className='fab fa-twitter text-white' />
        </a>,
        <a href='https://www.instagram.com/mineducacao' alt='instagram' className="mr-1">
            <i className='fab fa-instagram text-white' />
        </a>,
    ];

    const footerElementsLeft = [
        {   imgSrc: acessoInformacao, // Unico parametro obrigatorio
            imgAlt: 'Portal de Acesso à Informação',  
            href: 'https://www.acessoainformacao.gov.br/'
        },
    ];

    return (
        <>
        <div style={{paddingTop: '50px'}}/> {/* Pra dar um espacamento do elemento acima */}
        <footer className={`br-footer ${fundoInvertido? "inverted" : ""}`} id="footer" >
            <div className={` ${larguraFixa? "container-lg" : "container-fluid px-4"}`}>
                <div className="logo text-center text-md-left" >
                    <a href='https://www.gov.br/mec/pt-br' title='Ministério da Educação'>
                        <img src={props.logo || logoGovBR} alt="Logo GovBR" />
                    </a>
                </div>

                <div className="br-list" collapsible horizontal two-lines unique data-sub>

                    {categorias.map((cat, idx) => {
                        return (
                            <div className="col" key={'footer_cat_'+idx}>
                                <a className="br-item" link>
                                    <div className="content text-down-01 text-bold text-uppercase">
                                        {cat.name}
                                    </div>
                                    {/* <div className="support"><i className="fas fa-angle-up"></i></div> */}
                                </a>
                                <div className="br-list">

                                    {cat.itens.map((item, inner_idx) => {
                                        return (<a className="br-item" key={`cat_${idx}_it_${inner_idx}`} link>
                                                    <div className="content">{item}</div>
                                                </a>);
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="container-fluid">
                    <div className="row align-items-end justify-content-between py-2">
                        <div className="col social-network px-0">

                            {mostrarTituloRedeSocial && 
                                <p className="text-up-01 text-extra-bold text-uppercase pb-3">
                                    Redes Sociais
                                </p>
                            }

                            {redesSociais.map((Componente, index) => {
                                return Componente;
                            })}
                        </div>
                        <div className="col assigns text-right px-0">

                            {footerElementsLeft.map((item, index) => {
                                return (
                                    <a
                                        {...(item.href && {href: item.href})}
                                        key={'footer_elements_left_'+index}
                                        title={item.imgAlt}
                                        alt={item.imgAlt}
                                        className='mr-2'
                                    >
                                        <img src={item.imgSrc} alt={item.imgAlt} />
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="br-divider my-3"></div>
            <div className="container-lg">
                <div className="info">
                    <div className="text-down-01 text-medium pb-3 text-center">
                    <span className=''>{systemName} {backendVer && (`v${backendVer.app_version} | Laravel v${backendVer.laravel_version}`)}</span>
                    <br/>
                    <span className=''>
                    © {new Date().getFullYear()} Ministério da Educação - Governo Federal
                    </span>

                    </div>
                </div>
            </div>
        </footer>
        </>
        );
}

export default Footer;
